import DeleteIcon from '@/assets/images/signatures/delete.png';
import CornerIcon from '@/assets/images/signatures/corner_control.png';

export const SIGNATURE_PAD_RATIO = 5 / 3;
export const DEFAULT_SIGNATURE_WIDTH = 75;
export const MIN_SIGNATURE_WIDTH = 50;
export const MAX_SIGNATURES_PER_PAGE = 1;
export const DEFAULT_CORNER_SIZE = 14;
export const PDF_RENDER_SCALE = 1.5;

export const STYLE_COLORS = {
  FILL: 'rgba(63, 131, 248, 0.2)', // Light blue background
  STROKE: '#3F83F8', // Primary blue border
  BORDER_TRANSPARENT: 'rgba(255, 255, 255, 0)',
  CORNER_FILL: 'white',
  CORNER_STROKE: 'red',
};

export const OPACITY_DISABLED = 0.5;
export const OPACITY_ENABLED = 1;

export const DOCUMENT_SIGNED_STATUSES = {
  STATUS_UNANNOTATED: 'unannotated',
  STATUS_ANNOTATED: 'annotated',
  STATUS_SIGNED: 'signed',
};

export const SIGNATURE_ICONS = {
  DELETE: DeleteIcon,
  CORNER: CornerIcon,
};
